module.exports = __webpack_public_path__ + "static/media/mouse.cc637e3a.svg";